export interface BreadcrumbParts {
  path: string;
  last: string;
}

export function pointsText(points: number): string {
  return `${points} ${points === 1 ? 'pt' : 'pts'}`;
}

export function withoutNumberDash(label: string): string {
  return label.replace(/^(\S+) - /, '$1 ');
}

export function splitBreadcrumb(breadcrumb: string): BreadcrumbParts {
  const separator = ' / ';
  const at = breadcrumb.lastIndexOf(separator);
  if (at < 0) return { path: '', last: breadcrumb };
  const end = at + separator.length;
  return { path: breadcrumb.slice(0, end), last: breadcrumb.slice(end) };
}
